import { useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useInView } from "framer-motion";
import TrendingMagnetCardSkeleton from "components/skeltons/TrendingMagnetCardSkeleton";
import { getMagnetPageLink } from "../../../utils/helpers";
import DefaultImage from "../../../assets/Images/BrandImage1.png";
import TrendingMagnetCard from "../TrendingMagnetCard";

type Props = {
  magnets: PublicMagnet[];
  onLastElementVisible: () => void;
  trendingMagnetsLoading: boolean;
};

function MagnetCarousel({ magnets, onLastElementVisible, trendingMagnetsLoading }: Props) {
  const navigate = useNavigate();
  const lastTrendingRef = useRef(null);
  const isInView = useInView(lastTrendingRef);

  useEffect(() => {
    if (isInView) onLastElementVisible();
  }, [isInView]);

  return (
    <div className="secondary-scrollbar flex snap-x gap-5 overflow-x-scroll pb-4 2xl:gap-6">
      {magnets.map((magnet) => (
        <div
          onKeyDown={() => {}}
          tabIndex={0}
          role="button"
          key={`moreMags${magnet.id}`}
          className="cursor-pointer snap-center md:snap-start"
          onClick={() => {
            navigate(getMagnetPageLink(magnet.brand_id, magnet.id));
            window.scrollTo(0, 0);
          }}
        >
          <TrendingMagnetCard
            name={magnet.name}
            release={magnet.release}
            imageUrl={magnet.image_url || DefaultImage}
            hideComingSoon={magnet.is_magnet_interaction_blocked}
          />
        </div>
      ))}
      {trendingMagnetsLoading && <TrendingMagnetCardSkeleton />}
      <div ref={lastTrendingRef} className="p-5" />
    </div>
  );
}
export default MagnetCarousel;
